module.exports = __webpack_public_path__ + "8e0efd425e83845acb205d2d159a7985.png";